import { render } from "./PLgroupDSidebar.vue?vue&type=template&id=4b4351e2"
import script from "./PLgroupDSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PLgroupDSidebar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/PLgroupDSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b4351e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b4351e2', __exports__)) {
    api.reload('4b4351e2', __exports__)
  }
  
  module.hot.accept("./PLgroupDSidebar.vue?vue&type=template&id=4b4351e2", () => {
    api.rerender('4b4351e2', render)
  })

}


export default __exports__